module.exports = __webpack_public_path__ + "img/hesuan.a90de2e0.png";